import {BaseAppPrefs} from "../shared/BaseAppPrefs";

export class AppPrefs extends BaseAppPrefs {

  static readonly PREF_AUTOSEND_CHAT = "autosend_chat";
  static readonly PREF_AUTOSWITCH_CALL_TURN = "autoswitch_call_turn";
  static readonly PREF_IMAGE_DATA_PREFIX = "image_data_";

  private static instance: AppPrefs;

  static getInstance() {
    if (!this.instance) {
      this.instance = new AppPrefs();
    }
    return this.instance;
  }

  private constructor() {
    super();
  }

  getAutosendChat(): boolean {
    return this.prefs.getBoolean(AppPrefs.PREF_AUTOSEND_CHAT);
  }

  setAutosendChat(autoSend: boolean): void {
    this.prefs.setBoolean(AppPrefs.PREF_AUTOSEND_CHAT, autoSend);
  }

  getAutoswitchCallTurn(): boolean {
    return this.prefs.getBoolean(AppPrefs.PREF_AUTOSWITCH_CALL_TURN);
  }

  setAutoswitchCallTurn(autoSwitch: boolean): void {
    this.prefs.setBoolean(AppPrefs.PREF_AUTOSWITCH_CALL_TURN, autoSwitch);
  }

  getImageData(type: string): string | null {
    return this.prefs.getString(AppPrefs.PREF_IMAGE_DATA_PREFIX + type);
  }

  setImageData(type: string, data: string | null): void {
    this.prefs.setString(AppPrefs.PREF_IMAGE_DATA_PREFIX + type, data);
  }
}
